import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import React from 'react';
import PropTypes from 'prop-types';
import { SearchBar } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
const StyledSearchBar = /*#__PURE__*/_styled(SearchBar, {
  target: "e367amp0",
  label: "StyledSearchBar"
})(process.env.NODE_ENV === "production" ? {
  name: "1govlv3",
  styles: "flex:1;width:auto;margin-right:1rem"
} : {
  name: "1govlv3",
  styles: "flex:1;width:auto;margin-right:1rem",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhTGlicmFyeS9Db21tb24vTWVkaWFTZWFyY2hCYXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUt5QyIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9NZWRpYUxpYnJhcnkvQ29tbW9uL01lZGlhU2VhcmNoQmFyLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgU2VhcmNoQmFyIH0gZnJvbSAnZGVjYXAtY21zLXVpLW5leHQnO1xuXG5jb25zdCBTdHlsZWRTZWFyY2hCYXIgPSBzdHlsZWQoU2VhcmNoQmFyKWBcbiAgZmxleDogMTtcbiAgd2lkdGg6IGF1dG87XG4gIG1hcmdpbi1yaWdodDogMXJlbTtcbmA7XG5cbmZ1bmN0aW9uIE1lZGlhU2VhcmNoQmFyKHsgdmFsdWUsIG9uQ2hhbmdlLCBvbktleURvd24sIHBsYWNlaG9sZGVyLCBkaXNhYmxlZCB9KSB7XG4gIHJldHVybiAoXG4gICAgPFN0eWxlZFNlYXJjaEJhclxuICAgICAgdmFsdWU9e3ZhbHVlfVxuICAgICAgb25DaGFuZ2U9e29uQ2hhbmdlfVxuICAgICAgb25LZXlEb3duPXtvbktleURvd259XG4gICAgICBwbGFjZWhvbGRlcj17cGxhY2Vob2xkZXJ9XG4gICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgLz5cbiAgKTtcbn1cblxuTWVkaWFTZWFyY2hCYXIucHJvcFR5cGVzID0ge1xuICB2YWx1ZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgb25DaGFuZ2U6IFByb3BUeXBlcy5mdW5jLmlzUmVxdWlyZWQsXG4gIG9uS2V5RG93bjogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgcGxhY2Vob2xkZXI6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgZGlzYWJsZWQ6IFByb3BUeXBlcy5ib29sLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTWVkaWFTZWFyY2hCYXI7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function MediaSearchBar({
  value,
  onChange,
  onKeyDown,
  placeholder,
  disabled
}) {
  return ___EmotionJSX(StyledSearchBar, {
    value: value,
    onChange: onChange,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    disabled: disabled
  });
}
MediaSearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export default MediaSearchBar;